import React, { useState, useEffect, useRef } from 'react';
import './CustomSearch2.css';
import { HandySvg } from "handy-svg";
import broomstick from "./img/metla.svg"

const CustomSearch3 = ({
                           name,
                           data,
                           selected = ()=>{},
                           idSelectedItem = ()=>{},
                           dropdown_wrapper_modifikator,
                           dropdown_header_modifikator,
                           clearFull,
                           sendClearFilters,
                           initialValue = null,
                           dropdown_content_modifClass,
                       }) => {

    const [isOpen, setIsOpen] = useState(false);
    const [filter, setFilter] = useState(initialValue || '');
    const [selectedItem, setSelectedItem] = useState(null);
    const dropdownRef = useRef(null);
    const debounceTimeout = useRef(null);
    const isInitialMount = useRef(true);

    const [dataProcessed, setDataProcessed] = useState(false);

    useEffect(() => {

        if (data && data.length > 0 && !dataProcessed) {
            setDataProcessed(true);

            // При первом монтировании используем initialValue вместо первого элемента
            if (initialValue) {
                const matchingItem = data.find(item => {
                    const displayValue = typeof item === 'object'
                        ? (item.name || 'Неизвестно')
                        : item;
                    return displayValue === initialValue;
                });

                if (matchingItem) {
                    const itemId = matchingItem.id || matchingItem.guid;
                    setSelectedItem(matchingItem);

                    if (typeof idSelectedItem === 'function') {
                        idSelectedItem(itemId);
                    }
                }
            } else {
                // Только если нет initialValue, устанавливаем первый элемент
                const firstItem = data[0];
                const itemValue = typeof firstItem === 'object'
                    ? (firstItem.name || 'Неизвестно')
                    : firstItem;
                const itemId = firstItem.id || firstItem.guid;

                setFilter(itemValue);
                setSelectedItem(firstItem);

                if (typeof selected === 'function') {
                    selected(itemValue);
                }
                if (typeof idSelectedItem === 'function') {
                    idSelectedItem(itemId);
                }
            }
        }
    }, [initialValue,data]);

    useEffect(() => {
        setFilter(initialValue || '');
    }, [initialValue]);

    useEffect(() => {
        if (clearFull === true) {
            clearValueSelect();
            sendClearFilters(false);
        }
    }, [clearFull]);

    const sendData = (value) => {
        if (typeof selected === 'function') {
            selected(value);
        }
    };

    const getId = (value) => {
        if (typeof idSelectedItem === 'function') {
            idSelectedItem(value);
        }
    }

    const toggleDropdown = () => {
        setIsOpen(prev => !prev);
    };

    const handleFilterChange = (event) => {
        const newValue = event.target.value;
        let formattedDate = newValue;

        if (formattedDate.trim() === '') {
            setFilter("");
            sendData('');
            getId(null);
        }

        if (newValue.match(/\d{4}-\d{2}-\d{2}/)) {
            const dateParts = newValue.split('-');
            formattedDate = `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
        }
        setFilter(newValue);

        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        debounceTimeout.current = setTimeout(() => {
            const matchingItem = data.find(item => {
                const displayValue = typeof item === 'object' ? ('Неизвестно') : item;
                return displayValue.toLowerCase().includes(newValue.toLowerCase());
            });

            if (matchingItem) {
                const id = matchingItem.id || matchingItem.guid;
                sendData(newValue);
                getId(id);
            } else {
                sendData(newValue);
                getId(null);
            }
        }, 300);
    };

    useEffect(() => {
        return () => {
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
        };
    }, []);

    const handleItemSelect = (item, index) => {
        setSelectedItem(item);
        const itemId = item.guid || item.id;
        const itemValue = item.name || item;

        setFilter(itemValue);
        if (typeof selected === 'function') {
            selected(itemValue);
        }
        if (typeof idSelectedItem === 'function') {
            idSelectedItem(itemId);
        }
        setIsOpen(false);
    };

    function clearValueSelect(){
        setFilter("");
        sendData('');
        getId(null);
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const filteredData = data.filter(item => {
        const displayValue = typeof item === 'object' ? (item.name || 'Неизвестно') : item;
        return displayValue.toLowerCase().includes(filter.toLowerCase());
    });

    return (
        <div className={`dropdown_wrapper ${dropdown_wrapper_modifikator}`} ref={dropdownRef}>
            <div className={`dropdown_header ${dropdown_header_modifikator}`}>
                <div className={`dropdown_name`}>{name}</div>
                <div className={"search_util_icons_container"}>
                    <HandySvg src={broomstick} onClick={clearValueSelect} className="arrow_filters" />
                </div>
            </div>
            <div className={"dropdown"} onClick={() => { setSelectedItem(null) }}>
                <input
                    type="text"
                    placeholder={name}
                    value={filter}
                    onChange={handleFilterChange}
                    onClick={toggleDropdown}
                    className="myInput"
                />
                {isOpen && (
                    <div className={`dropdown-content-wrapper ${dropdown_content_modifClass}`}>
                        <div className="dropdown-content">
                            {filteredData.length > 0 ? (
                                filteredData.map((item, index) => {
                                    const displayValue = typeof item === 'object' ? (item.name || item.fio || 'Неизвестно') : item;
                                    return (
                                        <div
                                            key={index}
                                            onClick={() => handleItemSelect(item)}
                                            className="dropdown-content-item"
                                        >
                                            {displayValue}
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="dropdown-content-item no-results">Совпадений не найдено</div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CustomSearch3;